var exports = {
  "kL": "xe564cbfb--5fa88e--container",
  "DY": "xe564cbfb--5fa88e--click-area",
  "VH": "xe564cbfb--5fa88e--preview",
  "Yq": "xe564cbfb--5fa88e--reviews",
  "tp": "xe564cbfb--5fa88e--content-inner",
  "Qs": "xe564cbfb--5fa88e--content",
  "wx": "xe564cbfb--5fa88e--header",
  "DD": "xe564cbfb--5fa88e--title",
  "WD": "xe564cbfb--5fa88e--labels",
  "O3": "xe564cbfb--5fa88e--underground",
  "hl": "xe564cbfb--5fa88e--address",
  "XU": "xe564cbfb--5fa88e--advertises",
  "qr": "xe564cbfb--5fa88e--footer",
  "M3": "xe564cbfb--5fa88e--contacts",
  "iU": "xe564cbfb--5fa88e--message",
  "LQ": "xe564cbfb--5fa88e--rooms",
  "BI": "xe564cbfb--5fa88e--favorite",
  "cL": "xe564cbfb--5fa88e--builder",
  "Uo": "xe564cbfb--5fa88e--buttons",
};

module.exports = exports;
